export var COMPANY_DETAILS = '/';
export var INDUSTRY = '/industry';
export var TAGS = '/tags';
export var FILTER = '/filter';
export var LOGO_LIST = '/logo-list';
export var EDIT_LOGO = '/edit-logo';
export var PREPREMIUM = '/prepremium';
export var PREMIUM = "/premium";
export var MY_LOGOS = "/my-logos";
export var DASHBOARD = "/dashboard";
export var ANY_DASHBOARD = DASHBOARD + "/*";
export var PRINTS_EDITOR = "/prints/editor/";
export var PRINTS_EDITOR_BUSINESS_CARDS = PRINTS_EDITOR + "business_cards";
export var PRINTS_EDITOR_WITH_PARAM = PRINTS_EDITOR + ":editType";
export var PRINTS_EDITOR_WITH_ITEMID = PRINTS_EDITOR + ":editType/edit/:itemId";
export var PRINTS_LOGO_PICKER = "/prints/logo-picker";
export var PRINTS_CHECKOUT = "/prints/checkout";
export var PRINTS_THANKYOU = "/prints/thankyou";
export var PRINTS_PRODUCTS = "/prints/products";
export var WEBSITE = "/website";
export var THANK_YOU = "/thankyou";
export var THANK_YOU_WEBSITE = "/thankyou/website";
export var DASHBOARD_MY_LOGOS = DASHBOARD + "/my-logos";
export var DASHBOARD_PRINTS = DASHBOARD + "/prints";
export var DASHBOARD_PRINT_SHOP = DASHBOARD + "/printShop";
export var DASHBOARD_BRAND_STUDIO = DASHBOARD + "/brand-studio";
export var SHORTEN = '/shorten';
export var SHARE = '/share';
export var PREMIUM_CHECKOUT = '/premium-checkout';
export var ZOE_EDITOR = '/zoe-editor';
export var ADMIN_PURCHASES = '/admin/purchases';
export var ZOE_TEMPLATES = '/zoe-templates';
export var USER_INFO_ROUTE = '/';
export var ARENA_SPLIT_PAGE_ROUTE = '/arena';
export var PRINTS_STANDALONE = '/print';
export var ARENA_SPLIT_PAGE_BASE_PATH = '/';
export var onBoardingRoutes = [COMPANY_DETAILS, INDUSTRY, TAGS, FILTER];
export var logoContextRoutes = [PREPREMIUM, PREMIUM, DASHBOARD_MY_LOGOS, PREMIUM_CHECKOUT, ZOE_EDITOR, DASHBOARD_BRAND_STUDIO];